import React, { Component } from 'react';
import { prop, propOr } from 'ramda';
import Translate from 'react-translate-component';

class DocumentTable extends Component {
    render() {
        const { rows, columns } = this.props;

        return (
            <table className='xml-table'>
                <thead>
                    <tr>
                        { columns.map((column, index) => {
                            const translatePath = prop('columnTranslatePath', column);

                            return (
                                <td key={index}>
                                    {translatePath ? <Translate content={translatePath}/> : null}
                                </td>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    { rows.map((row, index) => {
                        return (
                            <tr key={index}>
                                { columns.map((column, index) => {
                                    if (column.getValue) {
                                        return (
                                            <td key={index}>
                                                {column.getValue(row) || ''}
                                            </td>
                                        );
                                    } else {
                                        const columnValuePath = prop('columnValuePath', column);
                                        const value = propOr('', columnValuePath, row);

                                        return (
                                            <td key={index}>
                                                {column.formatValue ? column.formatValue(value) : value}
                                            </td>
                                        );
                                    }
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }
}

export default DocumentTable;
